import stgConfig from "../../../config";
import imkt from '../imkt';

/**
 * Get an api endpoint relative to current environment
 * @todo: define what a dev environment is (BizBox?) in this context
 */

export default {
  urls: {
    apiGetAuthToken: {
      public:
        "https://www.atlassian.com/hamlet/1.0/auth/xsrf/html?domain=atlassian.com",
      staging: `${
        window.location.hostname.indexOf("qa-wac") > -1
          ? "https://qa-wac.internal.atlassian.com"
          : stgConfig.stgWacInternalUrl
      }/apis/stg/hamlet/1.0/auth/xsrf/html?domain=atlassian.com`,
      dev: "",
    },
    apiGetSites: {
      public: "https://api-private.atlassian.com/available-sites",
      staging: "https://api-private.stg.atlassian.com/available-sites",
      dev: "",
    },
    apiGetUser: {
      public: "https://api-private.atlassian.com/me",
      staging: "https://api-private.stg.atlassian.com/me",
      dev: "",
    },
  },

  getUrl: function (endpoint) {
    var env = imkt.constants.public ? "public" : "staging";
    var url =
      typeof this.urls[endpoint] !== "undefined"
        ? this.urls[endpoint][env]
        : "";
    return url;
  },
}
